import { Validators } from '@angular/forms';
import { GetCountriesData } from '@shared/interfaces/api.interfaces';
import { codeUKTZEDCanadaPattern } from '../components/parcel-places/ii-code-uktzed/ii-code-uktzed.constants';
import { DefaultCountryPhoneConfig } from '../international-invoice.constants';

// Canada
export const CA: Partial<GetCountriesData> = {
  ...DefaultCountryPhoneConfig,
  State: {
    getMethodName: 'getProvinciesOfCanada',
    config: {
      ariaLabel: 'Провінція',
      placeholder: 'Провінція',
      arrow: true,
    },
    errorSnackMessages: {
      empty: 'Не заповнено провінцію отримувача',
      fromList: 'Оберіть провінцію зі списку',
    },
  },
  CodeUKTZED: {
    validators: [
      Validators.pattern(codeUKTZEDCanadaPattern),
      Validators.required,
    ],
    resetFieldsWhenSwitchedToThisCountry: true,
    maxLength: 10,
  },
  CodeUKTZEDDest: {
    minLength: 10,
  },
  RecipientPayerAllowed: false,
};
